export default "__VITE_ASSET__BAcpDnTc__$_?nuxt_component=async&nuxt_component_name=SvgoAppStore&nuxt_component_export=default__"